import { useTranslation } from 'react-i18next';
import { cn } from '@shadcn/lib/utils';
import Button from './Button';

type Props = {
  variant?: 'light' | 'dark';
  onClick?: () => void;
  className?: string;
};

export function MicrosoftSignInButton({ variant = 'light', onClick, className }: Props) {
  const { t } = useTranslation();
  const theme =
    variant === 'dark'
      ? 'bg-[#2F2F2F] text-white border border-transparent hover:bg-[#3A3A3A]'
      : 'bg-white text-[#5E5E5E] border border-[#8C8C8C] hover:bg-[#F7F7F7]';
  const buttonVariant = variant === 'dark' ? 'secondary' : 'outline';

  return (
    <Button
      type="button"
      onClick={onClick}
      variant={buttonVariant}
      className={cn('w-full', theme, className)}
      aria-label={t('login.microsoft_login')}
    >
      <img
        src="/microsoft.svg"
        alt="Microsoft Logo"
        aria-label={t('login.microsoft_login')}
        width={21}
        height={21}
        className="w-[21px] h-[21px]"
        aria-hidden="true"
      />
      <span>{t('login.microsoft_login')}</span>
    </Button>
  );
}
